<template>
    <div  >
        <input type="checkbox" v-model="applyToPayment" @change="updateCheck" />
        <label>{{ paymentString }}</label>
    </div>
</template>

<script>
import format from '../../format.js'

export default {
    name:"applytopaymentdue",
    props:{
        account:{
            type:Object,
            required:true
        },

    },
    mixins:[format],
    components:{
        
    },
    data() {
        return {
           applyToPayment:false,
           nextPayment:{}
        };
    },
    methods:{
        formatAmount(amt){
            amt =this.$options.filters.toCurrency(amt)
            return  amt 
        },
        updateCheck(){
            this.$emit('checked',this.applyToPayment,this.nextPayment)
        },
        formatDateShort(dt){
            dt = this.$options.filters.formatDateShort(dt)
            return dt
        },
    },
    computed:{
        paymentString(){
            var nextPmt=null
            var mythis = this
            if(this.account.paymentPlan!=null){
                if(this.account.paymentPlan.PaymentPlanItemList.length>0){
                    this.account.paymentPlan.PaymentPlanItemList.forEach(myFunction2)
                    function myFunction2(item, index, arr) {
                        let payitem=arr[index]
                        console.log(payitem.PaymentAmount + ' ' + payitem.PaymentDueAmount)
                        if(payitem.PaymentAmount!=payitem.PaymentDueAmount && payitem.PaymentAccountTransactionID==0){
                            
                            if (nextPmt==null){
                                mythis.nextPayment=payitem
                                nextPmt="Apply to payment due on " + mythis.formatDateShort(payitem.PaymentDueDate) + " for " + mythis.formatAmount(payitem.PaymentDueAmount)
                            }
                            
                        }
                    } 
                }
                
            }
            return nextPmt
            
        },

       
    }
}
</script>

<style  >


</style>
